import React from 'react';
import { Tag } from 'antd';

/**
 * 促销类型多标签渲染组件
 * 后端多个促销类型用 # 连接（兼容历史 || 分隔符），拆分后逐个渲染为 Tag；空值显示 '-'
 */
const PromotionTypeTags = ({ value }) => {
  if (!value) return '-';
  const types = String(value).split(/#|\s*\|\|\s*/).filter(Boolean);
  if (types.length === 0) return '-';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
      {types.map((type, index) => (
        <Tag
          key={`${index}-${type}`}
          color="blue"
          style={{ marginInlineEnd: 0, whiteSpace: 'normal', textAlign: 'left' }}
        >
          {type}
        </Tag>
      ))}
    </div>
  );
};

export default PromotionTypeTags;
